import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

const initState = Map({
  callingClient: { address: '', number: '' }, //  呼叫中的客户号码和地址
  sipNumber: '', //  坐席SIP号
  callAgentStatus: 0, //  坐席呼叫状态 1： online, 2: offline, 3: rest, 4: busy,
  sipMessage: { message: {}, jsep: null }, //  sip插件消息
  janusErrorMessage: { message: '', code: '' }, //  janus 错误消息
  connecting: false, // 正在建立通话连接
  inCall: false, //  正在通话
  allowCall: true, // 是否允许通话
  // janus 注册数据
  registerData: {
    displayName: '',
    address: '60.205.184.193',
    port: '5688',
    server: ['wss://ubj.zy-yun.cn:8989', 'https://ubj.zy-yun.cn:8089/janus'],
    secret: 'mq20201716'
  },
  answerType: 'web:rtc', //  接听方式：web（工作台接听）、phone（手机接听）
  mobileNumber: '', //  手机接听手机号码
  summaryConfig: [], // 通话小结配置
  softSwitchMessage: { event: '', data: {} }, // 软电话消息
  softSwitchApplicationRegistered: true,
  // JsSip
  jssipMessage: { message: '', data: {} },
  uuid: '',
  callReport: {
    latencyTime: 0,
    preUpLossRate: 0,
    preDownLossRate: 0,
    downAudioLevel: 0,
    upAudioLevel: 0
  },
  // 对话条显示
  toolBarShowInfo: {
    trunkNumber: '',
    queueName: '',
    trunkNumberName: ''
  },
  //通过ws动态改变的呼叫状态：振铃，通话中   6：通话中  7：振铃中
  activeAgentStatus: 0,
  sipRegistered: true,
  currentCallInfo: {},
  fakeRecord: {}, // 当前通话中还未生成的通话记录
  selectedClient: {} // 当前选中的客户信息
});

export const {
  updateFakeRecordAction,
  updateCallingClientAction,
  setSipNumberAction,
  updateCallAgentStatusAction,
  updateSipMessageAction,
  updateConnectingAction,
  updateInCallAction,
  updateAllowCallAction,
  updateRegisterDataAction,
  updateJanusErrorMessageAction,
  updateSummaryConfigAction,
  updateAnswerTypeAction,
  updateMobileNumberAction,
  updateSoftSwitchMesageAction,
  updateSoftSwitchApplicationRegisteredAction,
  updateJssipMessageAction,
  updateUUidAction,
  updateToolBarShowInfoAction,
  updateActiveAgentStatusAction,
  updateSipRegisteredAction,
  updateCurrentCallInfoAction,
  updateSelectedClientAction,
  updateCallReportAction
} = createActions({
  updateCallingClientAction: action => {
    return action;
  },
  setSipNumberAction: action => {
    return action;
  },
  updateCallAgentStatusAction: action => {
    return action;
  },
  updateSipMessageAction: action => {
    return action;
  },
  updateConnectingAction: action => {
    return action;
  },
  updateInCallAction: action => {
    return action;
  },
  updateRegisterDataAction: action => {
    return action;
  },
  updateAllowCallAction: action => {
    return action;
  },
  updateJanusErrorMessageAction: action => {
    return action;
  },
  updateSummaryConfigAction: action => {
    return action;
  },
  updateAnswerTypeAction: action => {
    return action;
  },
  updateMobileNumberAction: action => {
    return action;
  },
  updateSoftSwitchMesageAction: action => {
    return action;
  },
  updateSoftSwitchApplicationRegisteredAction: action => {
    return action;
  },

  // Jssip
  updateJssipMessageAction: action => {
    return action;
  },
  updateUUidAction: action => {
    return action;
  },
  updateToolBarShowInfoAction: action => {
    return action;
  },
  updateActiveAgentStatusAction: action => {
    return action;
  },
  updateSipRegisteredAction: action => {
    return action;
  },
  updateCurrentCallInfoAction: action => {
    return action;
  },
  updateFakeRecordAction: action => {
    return action;
  },
  updateSelectedClientAction: action => {
    return action;
  },
  updateCallReportAction: action => {
    return action;
  }
});

const call = handleActions(
  {
    [updateCallingClientAction]: (state, action) => {
      const { client } = action.payload;
      return state.set('callingClient', { ...state.get('callingClient'), ...client });
    },
    [setSipNumberAction]: (state, action) => {
      const { sipNumber } = action.payload;
      return state.set('sipNumber', sipNumber);
    },
    [updateCallAgentStatusAction]: (state, action) => {
      const { status } = action.payload;
      return state.set('callAgentStatus', status);
    },
    [updateSipMessageAction]: (state, action) => {
      const { message } = action.payload;
      return state.set('sipMessage', message);
    },
    [updateConnectingAction]: (state, action) => {
      const { connecting } = action.payload;
      return state.set('connecting', connecting);
    },
    [updateInCallAction]: (state, action) => {
      const { inCall } = action.payload;
      return state.set('inCall', inCall);
    },
    [updateRegisterDataAction]: (state, action) => {
      const { data } = action.payload;
      const oldRegisterData = state.get('registerData');
      return state.set('registerData', { ...oldRegisterData, ...data });
    },
    [updateAllowCallAction]: (state, action) => {
      const { value } = action.payload;
      return state.set('allowCall', value);
    },
    [updateJanusErrorMessageAction]: (state, action) => {
      const { obj } = action.payload;
      return state.set('janusErrorMessage', obj);
    },
    [updateSummaryConfigAction]: (state, action) => {
      const { config } = action.payload;
      return state.set('summaryConfig', config);
    },
    [updateAnswerTypeAction]: (state, action) => {
      const { type } = action.payload;
      return state.set('answerType', type);
    },
    [updateMobileNumberAction]: (state, action) => {
      const { number } = action.payload;
      return state.set('mobileNumber', number);
    },
    [updateSoftSwitchMesageAction]: (state, action) => {
      const { message } = action.payload;
      return state.set('softSwitchMessage', message);
    },
    [updateSoftSwitchApplicationRegisteredAction]: (state, action) => {
      const { registered } = action.payload;
      return state.set('softSwitchApplicationRegistered', registered);
    },

    // Jssip
    [updateJssipMessageAction]: (state, action) => {
      const { message } = action.payload;
      return state.set('jssipMessage', message);
    },
    [updateUUidAction]: (state, action) => {
      const { uuid } = action.payload;
      return state.set('uuid', uuid);
    },
    [updateToolBarShowInfoAction]: (state, action) => {
      const { data } = action.payload;
      return state.set('toolBarShowInfo', data);
    },
    [updateActiveAgentStatusAction]: (state, action) => {
      const { data } = action.payload;
      return state.set('activeAgentStatus', data);
    },
    [updateSipRegisteredAction]: (state, action) => {
      const { data } = action.payload;
      return state.set('sipRegistered', data);
    },
    [updateCurrentCallInfoAction]: (state, action) => {
      const { data } = action.payload;
      return state.set('currentCallInfo', data);
    },
    [updateFakeRecordAction]: (state, action) => {
      const { data } = action.payload;
      return state.set('fakeRecord', data);
    },
    [updateSelectedClientAction]: (state, action) => {
      const { data } = action.payload;
      return state.set('selectedClient', data);
    },
    [updateCallReportAction]: (state, action) => {
      const { data } = action.payload;
      return state.set('callReport', data);
    }
  },
  initState
);

export default call;
